import siteContextStore, { GlobalLabels } from '@/shared/content/site-context.store';

export default function useGlobalLabels(blockName: GlobalLabels) {
    return siteContextStore.getGlobalLabels(blockName);
}
